/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

import User from '../views/user/User.vue';
import MappingMID from '../views/user/MappingMID.vue';
import MappingMIDDetail from '../views/user/MappingMIDDetail.vue';

import { setBreadcrumb } from './index';

const userRoute = {
  path: '/user',
  meta: {
    title: 'BNI QRIS - User',
    appBarTitle: 'User',
  },
  component: Parent,
  children: [
    {
      path: '',
      name: 'ListUser',
      meta: {
        title: 'BNI QRIS - List User',
        appBarTitle: 'List User',
        breadcrumbs: () => [
          setBreadcrumb('user management', '/user', true),
          setBreadcrumb('list user', '/user'),
        ],
      },
      component: User,
    },
    {
      path: '/mapping-mid',
      name: 'MappingMID',
      meta: {
        title: 'BNI QRIS - Mapping MID',
        appBarTitle: 'Mapping MID',
        breadcrumbs: () => [
          setBreadcrumb('user management', '/mapping-mid', true),
          setBreadcrumb('mapping MID', '/mapping-mid'),
        ],
      },
      component: MappingMID,
    },
    {
      path: '/mapping-mid/:action/:id(\\d+)?',
      name: 'MappingMIDDetail',
      meta: {
        title: 'BNI QRIS - Mapping MID',
        appBarTitle: 'Mapping MID',
        breadcrumbs: (params) => {
          const { action } = params;
          const { id } = params;
          const crumbs = [
            setBreadcrumb('user management', '/mapping-mid', true),
            setBreadcrumb('mapping MID', '/mapping-mid'),
            setBreadcrumb(action, `/mapping-mid/${action}`, true),
          ];
          if (id != null && id != '') {
            crumbs.push(
              setBreadcrumb(id, `/mapping-mid/${action}/${id}`, true)
            );
          }
          return crumbs;
        },
      },
      component: MappingMIDDetail,
    },
  ],
};
export default userRoute;
